<script>
  import { onMount } from 'svelte'
  import DataTable from '../DataTable/DataTable.svelte'
  import { Button } from 'smelte'
  import { conditionMonitoringAPI } from './api.js'
  import Icon from 'fa-svelte'
  import { faCircle } from '@fortawesome/free-solid-svg-icons'
  import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons'
  import { statusColor } from './utils'
  import { push, pop } from 'svelte-spa-router'
  import Metrics from '../Metrics.svelte'

  let columns = [
    {label: 'Machine model / Product group', field: 'platform', add: '', w: '24', iconAfter: true},
    {label: 'Name', field: 'name', add: '', w: '64', iconAfter: true},
    {label: 'Green', field: 'limits1', add: 'text-center', w: 20, iconAfter: true},
    {label: 'Yellow', field: 'limits2', add: 'text-center', w: 20, iconAfter: true},
    {label: 'Red', field: 'limits3', add: 'text-center', w: 20, iconAfter: true},
    {label: 'Function', field: 'func_fmt', add: '', w: 40, iconAfter: true},
    // {label: ' ', field: 'open', add: 'text-red-800 font-medium', w: '64', iconAfter: true},
  ]
  const funcNames = {
    'upper_bound': 'Upper bound',
    'lower_bound': 'Lower bound',
  }
  let data = []
  let selected = -1

  const api = new conditionMonitoringAPI()

  onMount(() => {
    api.getParamList()
      .then(res => {
        console.log('[DEBUG] params list view', res.data)
        if (!Array.isArray(res.data)) {
          return
        }
        res.data.forEach(p => {
          p.limits1 = p.limits[0].value / 1000
          p.limits2 = p.limits[1].value / 1000
          p.limits3 = p.limits[2].value / 1000

          p.func_fmt = funcNames[p.func] ? funcNames[p.func] : '-'
        })
        data = [...res.data].sort((a, b) => {
          if (a.platform < b.platform) return -1
          if (a.platform > b.platform) return 1
          return a.name < b.name ? -1 : 1
        })
      })
      .catch(err => {
        console.log('[ERROR]', err)
      })
  })

  function newParameterHandler () {
    push('/condition-monitoring/param/new')
  }

  function detailsOpenHandler ({detail}) {
    console.log('[DEBUG] handler', detail)
    push('/condition-monitoring/param/' + detail['_id'])
  }
</script>

<Metrics />

<div class="container mx-auto px-8 pt-1 pb-8 bg-white">

  <div class="flex header bg-white my-12">
    <div class="text-xl text-black text-left flex-grow">
      <span>MONITORING PARAMETERS</span>
      <span class="text-xl text-gray-600 ml-3 pb-1" on:click|stopPropagation>
            <a href={'https://software.support.flexlink.io/support/solutions/articles/35000177690-admin-settings-parameters-conveyor-condition-monitoring-tool'}
               target="_blank">
              <Icon icon={faQuestionCircle} />
            </a>
      </span>
    </div>
    <div class="flex-shrink">
      <Button color="red" remove="rounded" on:click={newParameterHandler}>create new parameter</Button>
    </div>
  </div>

  <div class="overflow-x-auto text-gray-700 overflow-y-auto" style="max-height: 500px">

    <DataTable {columns} {data}
               activationColumn={1}
               current={selected}
               selectable={false}
               minWidth={600}
               on:dblclick={detailsOpenHandler} />

  </div>

  <div class="mt-8 mb-5 w-full text-center">
    <Button text color="red" on:click={() => { pop() }}>GO Back</Button>
  </div>
</div>
